'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-dollar';
var width = 512;
var height = 512;
var aliases = ["dollar-circle","usd-circle"];
var unicode = 'f2e8';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm176-45.3c0-28 22.7-50.7 50.7-50.7l5.3 0 0-24c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24 40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-61.3 0c-19.1 0-34.7 15.5-34.7 34.7 0 17.4 12.9 32.1 30.1 34.4l46 6.1c25.2 3.4 44 24.8 44 50.2 0 28-22.7 50.7-50.7 50.7l-13.3 0 0 24c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-24-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l69.3 0c19.1 0 34.7-15.5 34.7-34.7 0-17.4-12.9-32.1-30.1-34.4l-46-6.1c-25.2-3.4-44-24.8-44-50.2z', 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c-4.4 0-8 3.6-8 8l0 24-5.3 0c-28 0-50.7 22.7-50.7 50.7 0 25.4 18.8 46.9 44 50.2l46 6.1c17.2 2.3 30.1 17 30.1 34.4 0 19.1-15.5 34.7-34.7 34.7L208 336c-4.4 0-8 3.6-8 8s3.6 8 8 8l40 0 0 24c0 4.4 3.6 8 8 8s8-3.6 8-8l0-24 13.3 0c28 0 50.7-22.7 50.7-50.7 0-25.4-18.8-46.9-44-50.2l-46-6.1c-17.2-2.3-30.1-17-30.1-34.4 0-19.1 15.5-34.7 34.7-34.7l61.3 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-40 0 0-24c0-4.4-3.6-8-8-8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;